import { useCallback, useState } from 'react';
import { RenderIf } from 'react-rainbow-components';
import { PicklistValue } from '@rainbow-modules/listview/lib/components/AuditLogs/types';
import Button from 'components/Button';
import User from 'components/icons/user';
import { Customer } from 'data/firestore/agent/customer/types';
import {
    Actions, Container, StyledButton, StyledCustomerPicker,
} from './styled';

interface CustomerEditorProps {
    agentId?: string;
    onUpdate?: (customerId: string) => Promise<boolean>;
}

const CustomerEditor = ({
    agentId = '',
    onUpdate = async () => true,
}: CustomerEditorProps) => {
    const [customer, setCustomer] = useState<Customer | null>();
    const [isLoading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const handleSaveClick = useCallback(
        async () => {
            if (!customer?.id) return;
            setLoading(true);
            const success = await onUpdate(customer.id);
            setLoading(false);
            if (success) {
                setCustomer(null);
                setEditMode(false);
            }
        },
        [customer, onUpdate],
    );

    const handleCancelClick = useCallback(
        () => {
            setCustomer(null);
            setEditMode(false);
        },
        [],
    );

    return (
        <Container>
            <RenderIf isTrue={editMode}>
                <StyledCustomerPicker
                    agentId={agentId}
                    name="event-details-customer"
                    placeholder="Find a Customer"
                    value={(customer || undefined) as unknown as PicklistValue}
                    onChange={setCustomer}
                    disabled={isLoading}
                />
                <Actions>
                    <Button
                        label="Cancel"
                        borderRadius="semi-rounded"
                        variant="outline-brand"
                        size="small"
                        onClick={handleCancelClick}
                        disabled={isLoading}
                    />
                    <Button
                        label="Save"
                        borderRadius="semi-rounded"
                        variant="brand"
                        size="small"
                        onClick={handleSaveClick}
                        disabled={isLoading || !customer?.id}
                    />
                </Actions>
            </RenderIf>
            <RenderIf isTrue={!editMode}>
                <StyledButton
                    size="small"
                    borderRadius="semi-rounded"
                    variant="base"
                    onClick={() => setEditMode(true)}
                >
                    <User />
                    Select Customer
                </StyledButton>
            </RenderIf>
        </Container>
    );
};

export default CustomerEditor;
